import axios from "axios";
import { API_GET_ADMINS_DATA, API_INSERT_ADMIN_DATA, API_LOGIN_ADMIN, API_TOGGLE_ADMIN_DATA, API_UPDATE_ADMIN_DATA, API_UPDATE_CURRENT_ADMIN_DATA } from ".";

export const loginAdmin = async (data) => {
    console.log("data is going")
    return axios.post(API_LOGIN_ADMIN, data).then(res => console.log(res))
}

export const getAdminsList = async (func, config) => {
    return axios.get(API_GET_ADMINS_DATA, config).then(res => func(res.data.data));
}

export const insertAdminData = async (data, config) => {
    return axios.post(API_INSERT_ADMIN_DATA, data, config).then((res) => res.data);
};

export const updateAdminData = async (data, config) => {
    return axios.put(API_UPDATE_ADMIN_DATA, data, config).then((res) => res.data);
};

export const updateCurrentAdminData = async (data, config) => {
    return axios.put(API_UPDATE_CURRENT_ADMIN_DATA, data, config).then((res) => res.data);
};

export const toggleAdminData = async (data, config, cb) => {
    return axios.patch(API_TOGGLE_ADMIN_DATA, data, config).then((res) => {
        if (res.data.status === "success") {
            cb();
        };
    });
};